export const API_BASE = process.env.REACT_APP_WEB_SEVER_API;
export const TRACKTRY_API_KEY = process.env.REACT_APP_TRACKTRY_API_KEY;